import { render, staticRenderFns } from "./MailLink.vue?vue&type=template&id=4a133058&"
import script from "./MailLink.vue?vue&type=script&lang=js&"
export * from "./MailLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a133058')) {
      api.createRecord('4a133058', component.options)
    } else {
      api.reload('4a133058', component.options)
    }
    module.hot.accept("./MailLink.vue?vue&type=template&id=4a133058&", function () {
      api.rerender('4a133058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gNK8t62JzWNO/JS/comp/MailLink.vue"
export default component.exports